import { WL_CONFIG } from 'constants';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  color: ${WL_CONFIG.colors.primary};
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  .icon {
    width: 16px;
    height: 16px;
    margin-left: 4px;
  }

  a {
    text-decoration: none;
    color: ${WL_CONFIG.colors.primary};

    &:hover {
      text-decoration: underline;
      color: ${WL_CONFIG.colors.primary};
    }
  }
`;
